import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import {
  useParams,
} from 'react-router-dom';

import meta from '../../config/meta';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

import FormAnswer from '../forms/FormAnswer.jsx';
import Padding from '../layout/Padding.jsx';
import Article from '../blocks/Article.jsx';
import ExtraReading from '../blocks/ExtraReading.jsx';
import KeyLearning from '../blocks/KeyLearning.jsx';
import NavMobileAssignment from '../blocks/NavMobileAssignment.jsx';
import ModalAnsRes from '../modals/ModalAnsRes.jsx';
import BtnExtraReadRemind from '../btns/BtnExtraReadRemind.jsx';

const PageAssignment = () => {
  const { date, lv } = useParams();
  const [re, setRe] = useState(undefined);
  const [res, req] = useHttpStatus();
  const [resModal, setResModal] = useState(false);
  const [activePane, setActivePane] = useState('article');
  const scrollRef = useRef();

  const extraRead = (score) => {
    setRe({
      ...(re || {}),
      answer: { ...re.answer, score, extraReading: true },
    });
  };

  useEffect(() => {
    req({
      url: `/api/quiz/assignments/${date}`,
    });
  }, [date, lv]);

  return (
    <PageHttp res={res}>
      {(doc) => {
        const { _id, article } = doc;
        const { extraReading, keyLearning } = article;
        let {
          answers: [answer],
          article: { questions },
        } = doc;

        meta.set({ title: article.title });

        if (re) {
          if (re.answer) answer = re.answer;
          if (re.questions) questions = re.questions;
        }

        return (
          <div className="position-relative">
            {/* modal after submit */}
            <ModalAnsRes
              answer={answer}
              extraReading={extraReading}
              keyLearning={keyLearning}
              show={resModal}
              onHide={() => setResModal(false)}
              onExtraRead={extraRead}
            />
            <NavMobileAssignment
              active={activePane}
              onChange={setActivePane}
            />
            <div className="container-fluid">
              <div className="row">
                <div
                  className={`
                    col-12 col-md p-0 shadow-r scrollable
                    ${activePane !== 'article' ? 'd-none d-md-block' : ''}
                  `}
                  style={{ zIndex: 2 }}
                  ref={scrollRef}
                >
                  <Padding className="pos-sticky bg-light py-3 d-none d-md-block">
                    <span className="mr-3">閱讀文章</span>
                    {moment(doc.date).format('YYYY年M月D日')}
                    <img
                      className="mx-2"
                      src={`/assets/img/${
                        answer
                          ? (moment(doc.date).isoWeekday(7).endOf('d').isAfter(moment(answer.createdAt)) ? 'read-green.svg' : 'read.svg')
                          : 'unfinished.svg'
                      }`}
                      style={{ width: '20px' }}
                    />
                  </Padding>
                  <Padding className="py-4">
                    <Article article={article} />
                    {
                      extraReading
                      && extraReading.url
                      && answer
                      && (
                        <BtnExtraReadRemind
                          onClick={() => {
                            const s = scrollRef.current;

                            s.scrollTo(0, s.scrollHeight);
                          }}
                        />
                      )
                    }
                  </Padding>
                  {answer && (
                    <Padding className="py-4 bg-lighter">
                      <div className="readable">
                        {keyLearning && (
                          <KeyLearning>
                            {keyLearning}
                          </KeyLearning>
                        )}
                        {extraReading && extraReading.url && (
                          <ExtraReading
                            assignment={doc}
                            onExtraRead={extraRead}
                            extraReading={extraReading}
                            answer={answer}
                          />
                        )}
                      </div>
                    </Padding>
                  )}
                </div>
                <div
                  className={`
                    col-12 col-md col-lg-auto p-0 bg-paper scrollable
                    ${activePane !== 'answer' ? 'd-none d-md-block' : ''}
                  `}
                  style={{ width: '460px' }}
                >
                  <FormAnswer
                    questions={questions}
                    answer={answer}
                    assignment={_id}
                    onSubmitted={(p) => {
                      setRe(p);
                      setResModal(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </PageHttp>
  );
};

export default PageAssignment;
